import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titlecaseWithSpace'
})
export class TitlecaseWithSpacePipe implements PipeTransform {

  transform(value: string): string {
    return value?.replace(/^./, value[0].toUpperCase()).replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
  }

}
